import React, { createContext, useContext, useEffect, useMemo } from 'react';
import useAuthTokens from '../utils/hooks/useAuthTokens';
import createAxiosClient from '../graphql/client';
import { useNavigate } from 'react-router-dom';

export const GraphQLClientContext = createContext();

export const GraphQLClientProvider = ({ children }) => {
  const { accessToken } = useAuthTokens();
  const navigate = useNavigate();
  const client = useMemo(
    () => createAxiosClient(accessToken, navigate),
    [accessToken, navigate]
  );

  return (
    <GraphQLClientContext.Provider value={client}>
      {children}
    </GraphQLClientContext.Provider>
  );
};

export const useAxiosClient = () => {
  return useContext(GraphQLClientContext);
};
